<template>
    <div @click="scan" class="monitor-box add-monitor">
        <div v-if="hasCloudlets" class="action-container">
            <font-awesome-icon icon="plus-circle"/>
            <span>Synchronize account</span>
        </div>
        <div v-if="!hasCloudlets" class="action-container">
            <p>Looks like You don't have any cloudlets for this account.</p>
            <p style="text-align:center;padding-top:20px;">
                <font-awesome-icon icon="plus-circle"/>
                <span>Synchronize account now</span>
            </p>
        </div>
    </div>
</template>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';

export default {
    props: ['account'],

    data() {
        return {
            scanning: false,
            cloudletsFoundWhileScanning: false,
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        scan() {
            if (this.scanning) {
                return;
            }

            this.scanning = true;

            Swal.fire({
                title: 'One moment',
                text: 'We are synchronizing your account.',
                type: 'info',
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading(),
                onBeforeOpen: () => {
                    Swal.showLoading();

                    let endpoint = 'accounts/' + this.account.id + '/synchronizations';

                    Api().post(endpoint)
                        .then((response) => {
                            Event.$emit('refreshAccountCloudlets', this.account.id, () => {
                                Swal.fire({
                                    title: 'Done!',
                                    text: 'Your account was synchronized.',
                                    type: 'success',
                                });
                            });
                        })
                        .catch((error) => {
                            var message = 'Something wrong happened.';

                            if (error.response.status == 429) {
                                message = 'You are not allowed to synchronize your account more than 3 times every 10 minutes.';
                            }

                            Swal.fire({
                                title: 'Oops',
                                text: message,
                                type: 'error',
                            });
                        })
                        .finally(() => {
                            this.scanning = false;
                        });
                },
            });
        },

        listenEvents() {
            Event.$on('accountCloudletsRefreshed', (accountId, refreshedCloudletsCount) => {
                if (refreshedCloudletsCount > 0) {
                    this.cloudletsFoundWhileScanning = true;
                }
            });
        },
    },

    computed: {
        hasCloudlets() {
            if (this.account.has_cloudlets) {
                return true;
            }

            return this.cloudletsFoundWhileScanning;
        },
    },
}
</script>
